import React from 'react';


class EmailInput extends React.Component {
  constructor(props){
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e){
    const email = e.target.value;
    if(email === ''){
      this.props.onChange(email);
      this.props.setValid(null);
    } else if(this.validate(email)){
      this.props.onChange(email);
      this.props.setValid(true);
    } else {
      this.props.onChange('');
      this.props.setValid(false);
    }
  }

  validate(email){
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email.toLowerCase());
  }

  render(){
    return(
      <input placeholder='Електронна адреса' type='text' onChange={ this.handleChange } className='input' noValidate/>
    );
  }
}

export default EmailInput;



// WEBPACK FOOTER //
// ./src/components/email_input/index.js